export default "__VITE_ASSET__Dd42IUrk__"